import { React, _n } from 'pexui';
import { BasePage } from '../base';
import { Html } from '../comps/html';
import { flow, getTrackLabel } from '../../models/flow';
import globals from '../../models/globals';
import { SUCCESSFUL_FIRST_LOAD_EVENT, SUCCESSFUL_COMPLETED_JOURNEY_EVENT } from '../../models/consts';
import { DocUploadService } from '../../services/docuploadsvc';
import { track, trackError } from '../../utilities/track';

export default class Nova extends BasePage {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    flow.raiseInvokerEvent('loaded', undefined);
    flow.lastChannel = 'NOVA';
  }

  invokeNovaWidget() {
    const {
      nova_identifier: novaUserArgs,
      transaction_id: transactionId,
      originator_id: originatorId,
      market: countryCode,
    } = flow.req;

    const { widget } = this.props;
    const { config } = globals;
    const { novaEnv, novaPublicId, novaProductId } = config;
    const { code: docRequestedCode } = flow.getCurrentNode();

    track('Nova', {
      contentName: getTrackLabel(flow.getCurrentNode()),
      selfServiceStart: true,
      events: !globals.event51Sent
        ? SUCCESSFUL_FIRST_LOAD_EVENT
        : undefined,
    });

    // Invoke widget with novaUserArgs
    window.Nova.register({
      env: novaEnv,
      publicId: novaPublicId,
      productId: novaProductId,
      userArgs: novaUserArgs,
      onSuccess: (publicToken, status) => {
        flow.raiseInvokerEvent('novaResponse', {
          transaction_id: transactionId,
          submission_channel_code: 'NOVA',
          documents_requested_code: docRequestedCode,
          received_timestamp: Date.now(),
          nova_response: {
            status,
            public_token: publicToken,
          },
        });

        DocUploadService.log2Server({
          transaction_id: transactionId,
          log_type: 'INFO',
          originator_id: originatorId,
          country_code: countryCode,
          log_message: `Nova completed successfully status: ${status}, publicToken: ${publicToken}`,
        });

        track('Nova:Success', {
          contentName: getTrackLabel(flow.getCurrentNode()),
          successStatus: `nova.${status}`,
        });

        if (flow.isNovaOnly()) {
          track('ThankYou', {
            events: SUCCESSFUL_COMPLETED_JOURNEY_EVENT
          });
        }
      },
      onError: (publicToken, error) => {
        flow.raiseInvokerEvent('message', {
          message: 'Nova error',
          error_code: error,
        });

        DocUploadService.log2Server({
          transaction_id: transactionId,
          log_type: 'ERROR',
          originator_id: originatorId,
          country_code: countryCode,
          log_message: `Error from Nova: ${error}`,
        });

        trackError(`nova.${error}`);
      },
      initialRoute: '/countrySelector',
      disableUnsupportedCountry: true,
      hideFinalIllustration: false,
      hideExitButton: true,
    });
  }

  hasHeader() {
    return false;
  }

  hasFooter() {
    return true;
  }

  hasHelp() {
    return false;
  }

  getFooterButtons() {
    return [{
      id: 'infw_btn_exit_nova',
      label: _n('exit.nova.label'),
      isPrimary: false,
      onClick: () => this.props.widget.onClose(),
    }];
  }

  renderContent() {
    return (
      <div>
        <script
          src="https://static.neednova.com/connect/v2/init.js"
          onLoad={this.invokeNovaWidget.bind(this)}
          onError={() => trackError('nova.SCRIPT')}
        />
        <div id="nova-embed" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./application/src/views/nova/nova.jsx